const Testimonial: React.FC<{ quote: string; author: string }> = ({ quote, author }) => (
    <div className="bg-white p-4 rounded-xl border border-dashed border-gray-600">
        <p className="text-sm md:text-base italic text-left">"{quote}"</p>
        <p className="text-right text-xs md:text-sm font-bold mt-2">- {author}</p>
    </div>
);

export default Testimonial;